import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { PermissionsService } from '../../services/permission.service';
import { DialogConfig, FormField } from '../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-step-phase',
  standalone:false,
  templateUrl: './step-phase.component.html',
  styleUrl: './step-phase.component.scss'
})
export class StepPhaseComponent implements OnInit , OnDestroy {
 title = 'Phase Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  private subscriptions = new Subscription();
  system: any[]=[]
  // isCardView: boolean = true;
  cols: any[] = [
    { field: 'name', header: 'Phase Name', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'description', header: 'Description', filterType: 'text',width: '200px', minWidth: '150px', maxWidth: '300px'  },
    { field: 'sequence', header: 'Sequence', filterType: 'text',width: '200px', minWidth: '150px', maxWidth: '300px'  },

  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false;
  selectedPhaseData: any = {};
  viewMode: boolean = false;
  
  // Dialog configurations
  addDialogConfig: DialogConfig;
  updateDialogConfig: DialogConfig;

  constructor(private api: ApiService, private messageService: MessageService , private permissionService: PermissionsService) { }

  ngOnInit(): void {
    // this.getSystem();
    this.initializeDialogConfigs();
  }

  private initializeDialogConfigs(): void {
    const phaseFields: FormField[] = [
      {
        key: 'name',
        label: 'Name',
        type: 'text',
        placeholder: 'Enter Phase Name',
        maxLength: 100,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Name must be alphanumeric and can include spaces and & only'
      },
      {
        key: 'description',
        label: 'Description',
        type: 'textarea',
        placeholder: 'Enter Description',
        maxLength: 500,
        validation: {
          required: true
        }
      },
      {
        key: 'sequence',
        label: 'Sequence',
        type: 'number',
        placeholder: 'Enter Sequence',
        maxLength: 2,
        validation: {
          required: true,
          pattern: '^[0-9]+$'
        },
        patternErrorMessage: 'Sequence must be a number'
      }
    ];

    this.addDialogConfig = {
      title: 'Create Phase',
      width: '60vw',
      fields: phaseFields,
      formLayout: 'single-column',
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-phase-dialog'
    };

    this.updateDialogConfig = {
      title: 'Update Phase',
      width: '60vw',
      fields: phaseFields,
      formLayout: 'single-column',
      submitButtonText: 'Update',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-phase-dialog'
    };
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
     const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/phase/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
       let resp = res.data || res.results
        this.totalRecords = res.count || 0
      this.system = resp.map((item: any) => ({
        ...item,
        section: item.section?.name,
        sectionName: item.section?.name || '',
        sectionCode: item.section?.code || '',
        status: item.status === 1 ? 'Active' : 'Inactive' // readable status
      }));
    });
    this.subscriptions.add(sub);
  }


  addSystem() {
    this.selectedPhaseData = {};
    this.showDialog = true;
  }

  onSubmitAdd(formData: any) {
    let payload = {
      name: formData.name,
      description: formData.description,
      sequence: formData.sequence,
    };
    
    const sub = this.api.postAPI('/master/phase/', payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Phase submitted successfully'
        });
        this.showDialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Failed to create phase'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onCancelAdd() {
    this.showDialog = false;
  }

  onCloseAdd() {
    this.showDialog = false;
  }

  viewSystem(rowData: any) {
    this.viewMode = true;
    this.updateDialogConfig.title = 'View Phase';
    if (rowData && rowData.id) {
      this.selectedsystem = rowData;
      this.isUpdatedialog = true;
      
      // Map data for the reusable dialog
      this.selectedPhaseData = {
        name: rowData.name || '',
        description: rowData.description || '',
        sequence: rowData.sequence || ''
      };
    }
  }

  updateSystem(equipment: any): void {
    this.viewMode = false;
    this.updateDialogConfig.title = 'Update Phase';
    this.isUpdatedialog = true;
    this.selectedsystem = equipment;
    
    // Map data for the reusable dialog
    this.selectedPhaseData = {
      name: equipment.name || '',
      description: equipment.description || '',
      sequence: equipment.sequence || ''
    };
  }


  onSubmitUpdate(formData: any) {
    let sectionId = this.selectedsystem.id;
    let payload = {
      name: formData.name,
      description: formData.description,
      sequence: formData.sequence,
    };
    
    const sub = this.api.putAPI(`/master/phase/${sectionId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Phase updated successfully'
        });
        this.isUpdatedialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Failed to update phase'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onCancelUpdate() {
    this.isUpdatedialog = false;
  }

  onCloseUpdate() {
    this.isUpdatedialog = false;
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment
  }
  deleteSystem() {
    // this.selectedsystem = equipment;
    let sectionId = this.selectedsystem.id
    const sub = this.api.deleteAPI(`/master/phase/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.showDeleteDialog = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Phase Deleted Successfully',
        });
        this.getSystem()

      },
      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the proposal. Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);
  }
    get canEditSetup(): boolean {
  return this.permissionService.hasPrivilege('/master/phase-master', 'Edit') ||
         this.permissionService.hasPrivilege('/master/phase-master', 'Delete')||
         this.permissionService.hasPrivilege('/master/phase-master', 'View');
}
}
